export const SUGGESTION_CATEGORIES = [
  '품질',
  '안전',
  '원가',
  '생산성',
  '환경',
  '기타',
] as const;

export type SuggestionCategory = (typeof SUGGESTION_CATEGORIES)[number];

export const ADOPTION_PENDING = 'PENDING';
export const ADOPTION_ADOPTED = 'ADOPTED';
export const ADOPTION_NOT_ADOPTED = 'NOT_ADOPTED';

export interface ImprovementSuggestionAttachment {
  attachmentId: number;
  fileName: string;
  fileExt?: string | null;
  fileSize?: number | null;
}

export interface ImprovementSuggestion {
  improvementSuggestionId: number;
  suggestionNo?: string | null;
  title: string;
  suggestDate?: string | null;
  proposerName?: string | null;
  department?: string | null;
  category?: string | null;
  currentSituation?: string | null;
  proposalContent?: string | null;
  expectedEffect?: string | null;
  remark?: string | null;
  status?: string | null;
  adoptionStatus?: string | null;
  implementationNote?: string | null;
  implementedAt?: string | null;
  contractId?: number | null;
  authorUserId?: number | null;
  authorName?: string | null;
  reviewerName?: string | null;
  approverName?: string | null;
  approverUserId?: number | null;
  canRevoke?: boolean | null;
  approvalInProgress?: boolean | null;
  pendingApprovalRequestId?: number | null;
  canCancelApproval?: boolean | null;
  attachmentCount?: number | null;
  attachments?: ImprovementSuggestionAttachment[] | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ImprovementSuggestionPayload {
  title: string;
  suggestDate?: string | null;
  proposerName?: string | null;
  department?: string | null;
  category?: string | null;
  currentSituation?: string | null;
  proposalContent?: string | null;
  expectedEffect?: string | null;
  remark?: string | null;
  contractId?: number | null;
}

export interface ImprovementSuggestionAdoptionPayload {
  adoptionStatus: string;
  implementationNote?: string | null;
  implementedAt?: string | null;
}

export function adoptionLabel(status?: string | null) {
  const s = (status || ADOPTION_PENDING).toUpperCase();
  if (s === ADOPTION_ADOPTED) return '채택';
  if (s === ADOPTION_NOT_ADOPTED) return '미채택';
  return '대기';
}
